<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="addActivityValue"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { resetObjectProperties } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import StepConfirm from './steps/StepConfirm.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    StepConfirm,
  },
  data() {
    return {
      model: {
        activity_id: null,
        businesses_id: [],
        extra_hours: null,
        number_extra_hours: null,
        farms_id: [],
        farmsNames: [],
        lotsNames: [],
        lots_id: [],
        checked: [],
        price: null,
        rateNumber: 1,
        rate_types_id: [],
        rate_types: [],
        rate_businesses_id: [],
        rate_farms_id: [],
        rate_lots_id: [],
        rate_type_delete: [],
        rate_values: [],
        relationRates: [],
        start_date: null,
        type: null,
      },
    };
  },
  mixins: [MixinPermissions, MixinMenu, MixinLoading, MixinAlert],
  computed: {
    tabsContent() {
      return [
        {
          title: i18n.t('common_words.general_information'),
          reference: 'firstStep',
          component: FirstStep,
        },
        {
          title: i18n.t('labor.hour_type'),
          reference: 'secondStep',
          component: SecondStep,
        },
      ];
    },
    hasSelectedLots() {
      return this.model.rate_types.filter((value) => value.lot);
    },
  },
  methods: {
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].checked = false;
      this.$refs.formWizard.$refs.firstStep[0].rateNumber = 1;
      this.$refs.formWizard.$refs.firstStep[0].count = 0;
      this.$refs.formWizard.$refs.firstStep[0].amountAvalible = [1, 1];
      this.$refs.formWizard.$refs.firstStep[0].model = {
        ...resetObjectProperties(
          this.$refs.formWizard.$refs.firstStep[0].model
        ),
        extra_hours: 0,
        number_extra_hours: null,
      };
      this.$refs.formWizard.$refs.secondStep[0].model = {
        ...this.$refs.formWizard.$refs.secondStep[0].model,
        timeType_number:
          this.$refs.formWizard.$refs.secondStep[0].timetypes.length,
      };
      this.$refs.formWizard.$refs.firstStep[0].listFarmsByBusiness;
      this.$refs.formWizard.$refs.firstStep[0].businessFiltered;
      this.$refs.formWizard.$refs.firstStep[0].filteredActivityrates;
      this.$refs.formWizard.$refs.firstStep[0].lotFilter;
      this.$refs.formWizard.$refs.firstStep[0].modelValidations.required = false;

      this.model = {
        ...resetObjectProperties(this.model),
        activity_id: null,
        extra_hours: null,
        number_extra_hours: null,
        price: null,
        start_date: null,
        type: null,
        rateNumber: 1,
      };
    },
    updateInSecondStep(editForm) {
      this.$refs.formWizard.$refs.secondStep[0].loadToUpdate(editForm);
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
    },
    alertResponse(response) {
      SweetAlert.continue(
        response.data.message ? response.data.message : response.errors
      ).then((result) => {
        if (result.value) {
          try {
            this.$refs.formWizard.$refs.wizard.reset();
          } catch (error) {}
          this.cleanAllSteps();
          sessionStorage.removeItem('editForm');
        } else if (result.dismiss) {
          this.$router.push('/works/activityvalues');
        }

        return result;
      });
    },
    addActivityValue() {
      this.showHideLoading(true);
      this.model.route = 'works/activityvalues';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('works');
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('works/activityvalues');
  },
};
</script>
